<template>
    <div class="diaryRow-item" :class="{disabled: !enabled}" align="center">
      <column-wrapper> <assistence ref="assistence" :title="'Asistencia'" :studentName="student.name" @updatedElement="detectElementChange" @statusChanged="disableColumn" :student="student" /> </column-wrapper>
      <column-wrapper> <breakfast ref="breakfast" :title="'Desayuno'" :studentName="student.name" @updatedElement="detectElementChange" :student="student" /> </column-wrapper>
      <column-wrapper>
        <div class="d-flex">
          <first-course-type ref="firstCourseType" :title="'1er plato'" :studentName="student.name" @updatedElement="detectElementChange" :student="student" />
          <first-course-value ref="firstCourseValue" :title="'1er Plato'" :studentName="student.name" @updatedElement="detectElementChange" :student="student" />
        </div>
      </column-wrapper>
      <column-wrapper> <second-course ref="secondCourse" :title="'2º Plato'" :studentName="student.name" @updatedElement="detectElementChange" :student="student" /> </column-wrapper>
      <column-wrapper>
        <div class="d-flex">
          <dessert-type ref="dessertType" :title="'Postre'" :studentName="student.name" @updatedElement="detectElementChange" :student="student" />
          <dessert-value ref="dessertValue" :title="'Postre'" :studentName="student.name" @updatedElement="detectElementChange" :student="student" />
        </div>
      </column-wrapper>
      <column-wrapper> <milk ref="milk" :title="'Leche'" :studentName="student.name" @updatedElement="detectElementChange" :student="student" /> </column-wrapper>
      <column-wrapper> <nap ref="nap" :title="'Siesta'" :studentName="student.name" @updatedElement="detectElementChange" :student="student" /> </column-wrapper>
      <column-wrapper> <deposition ref="deposition" :title="'Deposición'" :studentName="student.name" @updatedElement="detectElementChange" :student="student" /> </column-wrapper>
      <!-- <column-wrapper> <behaviour :title="''" :studentName="student.name" @updatedElement="detectElementChange" :student="student" /> </column-wrapper> -->
      <column-wrapper>
        <div class="d-flex">
          <snack-type ref="snackType" :title="'Merienda'" :studentName="student.name" @updatedElement="detectElementChange" :student="student" />
          <snack-value ref="snackValue" :title="'Merienda'" :studentName="student.name" @updatedElement="detectElementChange" :student="student" />
        </div>
      </column-wrapper>
      <column-wrapper>
        <message-text-area ref="message" :title="'Mensaje'" :studentName="student.name" @updatedElement="detectElementChange" :student="student" />
      </column-wrapper>
    </div>
</template>
<script>
import Assistence from '@/components/diaryElements/Assistence.vue'
import Behaviour from '@/components/diaryElements/Behaviour.vue'
import Breakfast from '@/components/diaryElements/Breakfast.vue'
import Deposition from '@/components/diaryElements/Deposition.vue'
import DessertType from '@/components/diaryElements/DessertType.vue'
import DessertValue from '@/components/diaryElements/DessertValue.vue'
import SnackType from '@/components/diaryElements/SnackType.vue'
import SnackValue from '@/components/diaryElements/SnackValue.vue'
import FirstCourseType from '@/components/diaryElements/FirstCourseType.vue'
import FirstCourseValue from '@/components/diaryElements/FirstCourseValue.vue'
import Milk from '@/components/diaryElements/Milk.vue'
import Nap from '@/components/diaryElements/Nap.vue'
import SecondCourse from '@/components/diaryElements/SecondCourse.vue'
import ColumnWrapper from '@/components/Elements/ColumnWrapper.vue'
import MessageTextArea from '../../diaryElements/MessageTextArea.vue'
export default {
  components: {
    Assistence,
    Breakfast,
    Deposition,
    FirstCourseType,
    FirstCourseValue,
    SecondCourse,
    DessertType,
    DessertValue,
    SnackType,
    SnackValue,
    Milk,
    Nap,
    Behaviour,
    ColumnWrapper,
    MessageTextArea
  },
  props: {
    id: undefined,
    pos: Number
  },
  created: function () {
    this.student = this.$attrs.student
  },
  data: () => ({
    student: {},
    enabled: true
    // students: []
  }),
  methods: {
    detectElementChange: function (item) {
      this.student = { ...this.student, ...item }
      console.log({detectElementChange: item})
      this.$emit('updatedStudent',
        { id: this.id, data: this.student }
      )
    },
    disableColumn: function (state) {
      console.log('disableColumn')
      const keys = Object.keys(this.$refs)
      this.enabled = state
      keys.forEach(function (key) {
        console.log(key)
        this.$refs[key].setEnable(state)
      }.bind(this))
      this.$emit('enableStudent', {id: this.pos, state})
    },
    updateColumn: function (column) {
      const key = Object.keys(column)[0]
      if (this.$refs[key]) this.$refs[key].setValue(column[key])
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/components/diaryType/BabyDiary/BabyDiaryRow.vue